import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import styles from './styles.css';

export default class Pagination extends Component {
    static propTypes = {
        maxPage: PropTypes.number.isRequired,
        active: PropTypes.number.isRequired,
        handlePreviousPage: PropTypes.func,
        handleNextPage: PropTypes.func,
        handlePageClick: PropTypes.func,
        range: PropTypes.number,
    };

    /**
     * @typedef {{
     * maxPage: number
     * active: number
     * handlePreviousPage: () => void
     * handleNextPage: () => void
     * handlePageClick: (page: number) => void
     * range?: number
     * }} PaginationProps
     * @type {PaginationProps}
     * */
    props = {};

    handlePageClick(number) {
        return () => this.props.handlePageClick(number);
    }

    render() {
        let { maxPage } = this.props;
        const {active, range = 2} = this.props;
        maxPage += 1;
        let startPage = 1;
        let endPage = maxPage;
        let pages = [];
        if (maxPage > 5) {
            if (active - range > 1) {
                pages.push(1);
            }
            if (active - range > 2) {
                pages.push('...');
            }
            startPage = Math.max(1, active - range);
            endPage = Math.min(maxPage, active + range);
            pages = pages.concat([...Array(endPage - startPage + 1)].map((_, i) => startPage + i));
            if (active + range < maxPage - 1) {
                pages.push('...');
            }
            if (active + range < maxPage) {
                pages.push(maxPage);
            }
        } else {
            pages = [...Array(maxPage + 1).keys()].slice(1);
        }

        if (pages.length === 0) return null;

        return (
            <div className={styles.root}>
                <button
                    className={classNames([styles.button, styles.arrow])}
                    onClick={this.props.handlePreviousPage}
                    disabled={active === 0}>
                    <i className='material-icons'>arrow_back</i>
                </button>
                {pages.map((number) => ( // number is 1 indexed
                    <button
                        key={number}
                        className={classNames(styles.button, {[styles.active]: active === number - 1})}
                        onClick={this.handlePageClick(number - 1)}
                        disabled={number === '...'}>
                        {number}
                    </button>
                ))}
                <button
                    className={classNames([styles.button, styles.arrow])}
                    onClick={this.props.handleNextPage}
                    disabled={active === maxPage - 1}>
                    <i className='material-icons'>arrow_forward</i>
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/pagination/index.js